import {
    RENTAL_PARTNER_DETAIL_SUCCESS,
    RENTAL_PARTNER_DETAIL_ERROR,
    RENTAL_PARTNER_DETAIL_START,
} from "Constant";


const initialState = {
    loading: false,
    data: {},
    message: null
};

export default function RentalPartnerDetailReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case RENTAL_PARTNER_DETAIL_START:
            return {
                ...state,
                loading: true,
            };
        case RENTAL_PARTNER_DETAIL_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case RENTAL_PARTNER_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
